import storeFactory from '@/helpers/storeFactory'
import orderBy from 'lodash.orderby'

export default storeFactory({
  model: {
    event_uuid: null,
    location_time: new Date(),
    location_place: null,
    delay: null,
    train_number: null,
    type: null
  },
  state: {
    places: []
  },
  getters: {
    advertisedPlaces(state) {
      return orderBy(
        state.places.map(x => {
          return {
            delay: x.delay_minutes,
            advertised: x.advertised,
            short_name: x.location,
            stop_name: x.location_long_name
          }
        }),
        ['advertised'],
        ['asc']
      )
    },

    newItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const delays = trafficMessageModel.delays
      const checkedItems = Object.values(state.data).filter(
        x => x.checked && !x.deleted
      )
      return checkedItems.filter(x => !delays.includes(x.uuid)).length
    },

    missingItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const delays = trafficMessageModel.delays
      const missingItems =
        delays?.filter(uuid => state.data[uuid] && !state.data[uuid].checked) ||
        []
      return missingItems.length
    },

    diffItemsCount(state, getters) {
      return getters['newItemsCount'] + getters['missingItemsCount']
    }
  }
})
